var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdrawals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 11.9987L12.6667 13.9987M12.6667 13.9987L14.6667 11.9987M12.6667 13.9987V9.9987M14.6667 6.66536H1.33333M14.6667 7.9987V5.46537C14.6667 4.71863 14.6667 4.34526 14.5213 4.06005C14.3935 3.80916 14.1895 3.60519 13.9386 3.47736C13.6534 3.33203 13.2801 3.33203 12.5333 3.33203H3.46666C2.71993 3.33203 2.34656 3.33203 2.06134 3.47736C1.81046 3.60519 1.60648 3.80916 1.47865 4.06004C1.33333 4.34526 1.33333 4.71863 1.33333 5.46536V10.532C1.33333 11.2788 1.33333 11.6521 1.47865 11.9374C1.60648 12.1882 1.81046 12.3922 2.06134 12.52C2.34656 12.6654 2.71992 12.6654 3.46666 12.6654H8",
    stroke: "#505050",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawals);
export default __webpack_public_path__ + "static/media/withdrawals.57733ebc087c0deb50e0ed3e5441e3b8.svg";
export { ForwardRef as ReactComponent };